import CrefisaLogo from "../assets/crefisa_logotipo.png";

export const useCrefisaWhiteLabelData = () => {
  const logo = CrefisaLogo;
  const name = "Crefisa";

  return { logo, name };
};
